import { Pipe, PipeTransform } from '@angular/core';
import { getAvatarUrl } from './user.functions';

@Pipe({
  name: 'avatar'
})
export class UserAvatarPipe implements PipeTransform {
    transform(inputValue?: any): string {
        return getAvatarUrl(inputValue);
    }
};